import PropTypes from 'prop-types';
import React from 'react';

import PageHeader from './pages/page-header';
import Video from './video';

const HeroImg = ({
	children,
	imgSrc,
	theme = 'dark',
	title,
	video_mp4,
	video_webm,
	withVideo = false,
	...props
}) => {
	const themeList = {
		dark: 'dark',
		light: 'light',
	};
	return (
		<section {...props}>
			<div className="hero-img-container position-relative">
				<div className="hero-content-container">
					<div className="container px-0">
						<div className="row align-items-center justify-content-center py-3">
							<div className="col-12 col-lg-6 col-xxl-10">
								{title && (
									<PageHeader
										pageVariant="hero"
										resetSpacing
										title={title}
										variant={themeList[theme]}
									/>
								)}
								{children ? children : null}
							</div>
						</div>
					</div>
				</div>
				{withVideo ? (
					<Video
						className=""
						poster={imgSrc}
						size="card"
						title={title}
						video_mp4={video_mp4}
						video_webm={video_webm}
					/>
				) : (
					<img alt={title} className="img-fluid" loading="lazy" src={imgSrc} />
				)}
				{title && (
					<div
						className={`dark-fade ${theme == 'light' ? 'd-none' : ''}`}
					></div>
				)}
			</div>
		</section>
	);
};

HeroImg.propTypes = {
	children: PropTypes.node,
	imgSrc: PropTypes.string,
	theme: PropTypes.string,
	title: PropTypes.string,
	video_mp4: PropTypes.string,
	video_webm: PropTypes.string,
	withVideo: PropTypes.bool,
};

export default HeroImg;
